import { createUseStyles } from 'react-jss';

export default createUseStyles({
  ViewPricingLink: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: 14,
    '& svg': {
      marginLeft: 3,
    },
  },
});
